import { Flex } from '@mantine/core';
import { useTargetsTabStore } from '../../../../../../store/strategy-store/strategy-store';
import { setVisibleMeasures } from '../../../../../../store/strategy-store/strategy-store.actions';
import { LineChartLegendItemWithCheckbox } from '../../../components/line-chart/line-chart-legend-item-with-checkbox';
import { getMeasureDataTypesColors, getMeasureDataTypesLabel } from '../../targets-tab.helpers';
import { MeasureDataType } from '../../targets-tab.type';

export const TargetsChartLegend = () => {
  const selectedTarget = useTargetsTabStore((state) => state.selectedTarget);
  const visibleMeasures = useTargetsTabStore((state) => state.visibleMeasures);

  const measureDataTypesColors = getMeasureDataTypesColors();

  const handleToggleMeasure = (measureType: MeasureDataType) => {
    setVisibleMeasures({
      ...visibleMeasures,
      [measureType]: !visibleMeasures[measureType],
    });
  };

  return (
    <Flex justify="center" align="center" gap="md" h="100%" wrap="wrap">
      {Object.values(MeasureDataType).map((measureType) => (
        <LineChartLegendItemWithCheckbox
          key={measureType}
          value={measureType}
          label={getMeasureDataTypesLabel(selectedTarget, measureType)}
          color={measureDataTypesColors[measureType]}
          isChecked={visibleMeasures[measureType]}
          onToggle={() => handleToggleMeasure(measureType)}
        />
      ))}
    </Flex>
  );
};
